import { render } from "./SearchTable.vue?vue&type=template&id=dbfcf4d2"
import script from "./SearchTable.vue?vue&type=script&lang=js"
export * from "./SearchTable.vue?vue&type=script&lang=js"

import exportComponent from "E:\\heguang\\hotel\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__